enum KeyboardEventKey {
  Escape = "Escape",
}

export default KeyboardEventKey;
